import React, { useEffect, useState } from 'react';
import styles from "./mobilemycoaching.module.css";
import { ReactComponent as MentorFirstPageSvg } from "../../../src/svg/pagesvgfirst.svg";
import { useHistory } from 'react-router-dom';


const MobileMyCoachingFirstPage: React.FC<any> = (props) => {

    const history = useHistory();
    

    useEffect(() => {

        console.log("MobileMyCoachingFirstPage props.statusDivHeight: ", props.statusDivHeight);

    }, [props.statusDivHeight]);


    return (
        <div>
            <div style={{
                paddingTop: "3rem",
                display: "flex",
                justifyContent: "center",
                fontSize: "1.8rem",
                fontFamily: "Apple_SB",
            }}>
                프로필을 작성해주세요!
            </div>
            <div style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
                paddingTop: "1.2rem",
                color: "#999",
                fontSize: "0.9rem"
            }}>
                수능선배 샤학관 재원생은 필수로 작성해야 합니다.<br></br>학습관리에 활용되니 작성해주시길 바랍니다.
            </div>
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "4rem"
            }}>
                <MentorFirstPageSvg
                    style={{
                        width: "13rem",
                    }}
                />
            </div>
            <div style={{
                position: "fixed",
                bottom: "1.5rem",
                display: "flex",
                justifyContent: "center",
                width: "100%",
            }}
                onClick={() => {

                    console.log(props.user);

                    if(!props.user) {
                        alert("로그인이 필요합니다.");
                        return;
                    }

                    history.push(
                        {
                            pathname: "/mobiledashboard/filloutembed",
                            state : {
                                userId : props.user.id,
                                filloutId : 'ik2iLRemuBus',
                                returnUrl : "/mobiledashboard/mycoaching",
                                nextCurrentStatus : 2,
                                title : "프로필 작성"
                            }
                        });
                }}
            >
                <div style={{
                    width: "90%",
                    backgroundColor: "#1b49af",
                    color: "#ffffff",
                    fontFamily: "Apple_SB",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "3rem",
                    borderRadius: "0.5rem",
                    cursor: "pointer",
                }}>
                    프로필 작성하기
                </div>
            </div>
        </div>
    )
}

export default MobileMyCoachingFirstPage;